import { render, staticRenderFns } from "./BaseCalendarPublic.vue?vue&type=template&id=001aaeb6&"
import script from "./BaseCalendarPublic.vue?vue&type=script&lang=ts&"
export * from "./BaseCalendarPublic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports